
<script setup>

  import { v4 as uuidv4 } from 'uuid';

  import { useMediaQuery } from '@vueuse/core';

  import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import SaveNotice from '../partials/save-notice.vue';

  import CurledPage from '../components/curled-page.vue';

  import { letterScenario, letterBackground, letterContent } from '../stores/activity-3.js';

  import backgroundPaths from '../images/activity-3-part-2-background-*.png';

  import backgroundPath from '../images/distressed-background.jpg';

  const letterContentId = uuidv4();

  const isLargeScreen = useMediaQuery( '(min-width: 1024px)' );

</script>

<template>

  <article>
    
    <div class="grid lg:grid-cols-2 bg-fixed bg-cover bg-center" :style="{ backgroundImage: `url( ${ backgroundPath } )` }"> 

      <div class="flex items-center justify-center min-h-view px-6 py-12">

        <div class="w-full max-w-xl">

          <div class="text-md font-bold uppercase">Step 3</div>

          <h3 class="pt-2 text-4xl font-heading uppercase">Write Your Letter</h3>

          <div class="flex items-center gap-6 mt-6 py-6 border-y-2 border-black">

            <img class="h-28" :src="backgroundPaths[ letterBackground ]" alt="" draggable="false" aria-hidden="true" />

            <div class="font-heading text-5xl">{{ letterScenario?.replace( /-/, ' ' ) }}</div>

          </div>

          <label class="block mt-8 text-xl leading-relaxed" :for="letterContentId">

            On the sheet of paper, write your letter to a family member describing your experience here at Lewis Mountain.

          </label>

          <CurledPage :id="letterContentId" class="h-view mt-12" v-model="letterContent" v-if="! isLargeScreen" />

          <SaveNotice class="mt-12" />

          <div class="flex flex-wrap justify-between mt-12">

            <RouterLink
            
              class="inline-flex items-center gap-4 px-6 py-4 font-bold bg-amber-300 transition-colors pointer-events-auto
              
                hover:bg-amber-400 focus-visible:bg-amber-400 hover:underline focus-visible:underline"
            
              to="/activity/3/part/2/step/2">

              <ArrowLeftCircleIcon class="w-8" />

              <span>Back</span>

            </RouterLink>

            <RouterLink
            
              class="flex items-center gap-4 px-6 py-4 font-bold text-white bg-green-700 transition-colors pointer-events-auto
              
                hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
            
              to="/activity/3/review">

              <span>Review</span>

              <ArrowRightCircleIcon class="w-8" />

            </RouterLink>

          </div>

        </div>

      </div>

      <div class="grid min-h-view p-12" v-if="isLargeScreen">

        <CurledPage :id="letterContentId" class="row-start-1 col-start-1 h-full" v-model="letterContent" />

      </div>

    </div>

  </article>

</template>